const DRIVER_FEE_PAYMENT_ACCOUNT = 1;
const DRIVER_ALLOWANCE_PAYMENT_ACCOUNT = 3;
const DRIVER_FINE_PAYMENT_ACCOUNT = 5;

const LOADER_FEE_PAYMENT_ACCOUNT = 2;
const LOADER_ALLOWANCE_PAYMENT_ACCOUNT = 4;
const LOADER_FINE_PAYMENT_ACCOUNT = 6;

const FUEL_PAYMENT_ACCOUNT = 7;
const EXPRESS_WAY_PAYMENT_ACCOUNT = 8;

export default function usePaymentAccount() {
  return {
    DRIVER_FEE_PAYMENT_ACCOUNT,
    DRIVER_ALLOWANCE_PAYMENT_ACCOUNT,
    DRIVER_FINE_PAYMENT_ACCOUNT,

    LOADER_FEE_PAYMENT_ACCOUNT,
    LOADER_ALLOWANCE_PAYMENT_ACCOUNT,
    LOADER_FINE_PAYMENT_ACCOUNT,

    FUEL_PAYMENT_ACCOUNT,
    EXPRESS_WAY_PAYMENT_ACCOUNT,
  };
}
